import { Injectable, ComponentFactoryResolver, Injector, ApplicationRef, ComponentRef } from '@angular/core';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackBarContainer: HTMLElement;

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {
    // Create a container element for the snackbar
    this.snackBarContainer = document.createElement('div');
    this.snackBarContainer.className = 'snackbar-container';
    document.body.appendChild(this.snackBarContainer);
  }

  show(message: string, duration?: number) {
    const factory = this.resolver.resolveComponentFactory(SnackbarComponent);
    const componentRef: ComponentRef<SnackbarComponent> = factory.create(this.injector);

    componentRef.instance.message = message;
    if (duration) {
      componentRef.instance.duration = duration;
    }
    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
    this.snackBarContainer.appendChild(domElem);

    // Cleanup after 3 seconds
    setTimeout(() => {
      this.snackBarContainer.removeChild(domElem);
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    }, 3000); // Adjust the duration as needed
  }
}
